import { type ActionItem } from 'shared/ui'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type IUser, type Permissions } from 'entities/Users/model/types'
import { type IResponseUser } from 'entities/Users/api/types'
import { DowngradeMemberStore } from 'pages/settings/pages/members/ui/actions/downgradeMember/ui/DowngradeMemberModal/store/DowngradeMemberStore'

export const downgradeMemberAction = (
  member: IUser,
  entities: IEntitiesStore,
  permissions: Permissions,
  useOrganizationSettings: boolean,
  onSuccess?: (member: IResponseUser) => void | Promise<void>
) => {
  const onDowngrade = () =>
    new DowngradeMemberStore(member, entities, permissions, useOrganizationSettings, onSuccess)

  return onDowngrade()
}

export const downgradeMember = (
  member: IUser,
  entities: IEntitiesStore,
  permissions: Permissions,
  useOrganizationSettings: boolean,
  onSuccess?: (member: IResponseUser) => void | Promise<void>
): ActionItem => {
  return {
    text: 'Downgrade member',
    icon: 'transfer',
    onAction: () => {
      downgradeMemberAction(member, entities, permissions, useOrganizationSettings, onSuccess)
    },
  }
}
